<template>
    <b-modal
            :visible="showModal === 'OrderStatisticParams'"
            @hidden="hideSearchModal"
            :lazy="true"
    >
        <div slot="modal-title">
            <h4>Статистика по параметрам</h4>
        </div>
        <form action="" method="post" сlass="form-horizontal">
            <div class="form-group row">
                <label class="col-md-3 form-control-label">Дата c</label>
                <div class="col-md-9">
                    <datepicker
                            v-model="params.dateFrom"
                            format="dd/MM/yyyy">
                    </datepicker>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label">Дата по</label>
                <div class="col-md-9">
                    <datepicker
                            v-model="params.dateTo"
                            format="dd/MM/yyyy">
                    </datepicker>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label">Город</label>
                <div class="col-md-9">
                    <multiselect
                            :options="cities"
                            :searchable="true"
                            :close-on-select="true"
                            :show-labels="false"
                            placeholder="Город не выбран"
                            track-by="id" label="name"
                            @input="changeCity"
                    >

                    </multiselect>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label">Компания</label>
                <div class="col-md-9">
                    <multiselect
                            v-model="companySelected"
                            :options="companies"
                            :searchable="true"
                            :close-on-select="true"
                            :show-labels="false"
                            placeholder="Компания не выбрана"
                            track-by="id" label="name"
                            @input="changeCompany"
                            :loading="loadingCompanies"
                    >

                    </multiselect>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label">Техцентр</label>
                <div class="col-md-9">
                    <multiselect
                            v-model="techcenterSelected"
                            :options="techcenters"
                            :searchable="true"
                            :close-on-select="true"
                            :show-labels="false"
                            placeholder="Техцентр не выбран"
                            track-by="id" label="name"
                            :loading="loadingTechcenters"
                    >

                    </multiselect>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label">Статус</label>
                <div class="col-md-9">
                    <multiselect
                            :value.sync="status"
                            :options="statuses"
                            :searchable="true"
                            :close-on-select="true"
                            :show-labels="false"
                            placeholder="Статус не выбран"
                            track-by="code" label="name"
                            @input="setStatus"
                    >
                    </multiselect>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-md-3 form-control-label">Менеджер</label>
                <div class="col-md-9">
                    <multiselect
                            :options="users"
                            :searchable="true"
                            :close-on-select="true"
                            :show-labels="false"
                            placeholder="Менеджер не выбран"
                            track-by="id" label="fullname"
                            @input="setUserId"
                            @open="loadUsers"
                            :loading="loadingUsers"
                    >
                    </multiselect>
                </div>
            </div>
        </form>
        <div slot="modal-footer" >
            <b-btn @click.prevent="hideSearchModal">Отменить</b-btn>
            <b-btn variant="primary" @click.prevent="search">Показать статистику заказов</b-btn>
        </div>
    </b-modal>
</template>
<script>
  import Multiselect from 'vue-multiselect'
  import { mapState, mapActions } from 'vuex'
  import moment from 'moment'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  import getTechcentersQuery from './../../gql/queries/getTechcenters.graphql'
  import getCompaniesQuery from './../../gql/queries/getCompanies.graphql'
  import getUsers from './../../gql/queries/getUsersForMultiselect.graphql'
  export default {
    computed: mapState({
      showModal: state => state.dashboardStore.showModal,
      cities: state => state.globalStore.cities,
      statuses: state => state.globalStore.statuses
    }),
    data () {
      return {
        format: 'DD/MM/YYYY',
        params: {
          dateFrom: '',
          dateTo: '',
          cityId: null,
          techcenterId: null,
          status: null,
          mode: 'search'
        },
        status: null,
        techcenters: [],
        techcenterSelected: null,
        loadingTechcenters: false,
        companies: [],
        companySelected: null,
        loadingCompanies: false,
        users: [],
        loadingUsers: false
      }
    },
    methods: {
      hideSearchModal () {
        this.$store.dispatch('dashboardShowModal', null)
      },
      search () {
        let params = Object.assign({}, this.params)
        if (params.dateFrom.trim() !== '') {
          params.dateFrom = moment(params.dateFrom, this.format).format('DD.MM.YYYY').toString()
        } else {
          return this.showError('Параметр дата c обязательно должен быть указан')
        }
        if (params.dateTo.trim() !== '') {
          params.dateTo = moment(params.dateTo, this.format).format('DD.MM.YYYY').toString()
        } else {
          return this.showError('Параметр дата по обязательно должен быть указан')
        }
        this.$store.dispatch('dashboardSetStatisticParams', params)
        this.hideSearchModal()
      },
      showError (error) {
        this.addToast({
          text: 'Произошла ошибка: ' + error,
          type: 'danger',
          dismissAfter: 10000
        })
      },
      changeCity (city) {
        this.companySelected = null
        this.params.companyId = null
        this.techcenterSelected = null
        this.params.techcenterId = null
        if (city) {
          this.params.cityId = city.id
          this.loadCompanies(city.id)
          this.loadTechcenters(city.id)
        } else {
          this.params.cityId = null
          this.loadCompanies()
          this.loadTechcenters()
        }
      },
      changeCompany (company) {
        this.techcenterSelected = null
        this.params.techcenterId = null
        if (company) {
          this.params.companyId = company.id
          this.loadTechcenters(this.params.cityId, company.id)
        } else {
          this.params.companyId = null
          this.loadTechcenters(this.params.cityId)
        }
      },
      /**
       * Загрузка техцентров
       */
      loadTechcenters (cityId = false, companyId = false) {
        this.loadingTechcenters = true
        this.techcenters = []
        this.params.techcenterId = null
        this.techcenterSelected = null
        let variables = {
          all: true
        }
        if (cityId) {
          variables.cityId = cityId
        }
        if (companyId) {
          variables.companyId = companyId
        }
        this.$apollo.query({
          query: getTechcentersQuery,
          variables: variables
        }).then(result => {
          this.techcenters = result.data.techcenters
          this.loadingTechcenters = false
        }).catch(error => {
          console.log(error)
          this.loadingTechcenters = false
        })
      },
      /**
       * Загрузка компаний для выбранного города
       */
      loadCompanies (cityId = false) {
        this.loadingCompanies = true
        let variables = {
          all: true
        }
        if (cityId) {
          variables.cityId = cityId
        }
        this.$apollo.query({
          query: getCompaniesQuery,
          variables: variables
        }).then(result => {
          this.companies = result.data.companies
          this.loadingCompanies = false
        }).catch(error => {
          console.log(error)
          this.loadingCompanies = false
        })
      },
      /**
       * Установка статуса в параметры
       * @param status
       */
      setStatus (status) {
        if (status !== null) {
          this.params.status = status.code
        } else {
          this.params.status = null
        }
      },
      /**
       * Установка пользователя в параметры
       * @param user
       */
      setUserId (user) {
        if (user !== null) {
          this.params.userId = user.id
        } else {
          this.params.user = null
        }
      },
      /**
       * Подргрузка менеджеров
       * активируется при открытии селекта
       */
      loadUsers () {
        this.loadingUsers = true
        this.$apollo.query({
          query: getUsers
        }).then(result => {
          this.users = result.data.users
          this.loadingUsers = false
        }).catch(error => {
          console.log(error)
          this.loadingUsers = false
        })
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    },
    components: {
//      modal,
//      datepicker,
      Multiselect
    }
  }
</script>




// WEBPACK FOOTER //
// ModalsOrdersStatisticParams.vue?345801e3